/* PDP pack contents chips — uses window.UG_PACK_INDEX */
(function () {
  var CONTENT_LABEL = {
    'drum loops': 'Drum loops', 'drum hits': 'Drum hits', 'drum kits': 'Drum kits',
    'bass loops': 'Bass loops', basslines: 'Basslines', bass: 'Bass',
    loops: 'Loops', 'one-shots': 'One-shots', 'one shots': 'One-shots',
    vocals: 'Vocals', vocal: 'Vocals', midi: 'MIDI', fx: 'FX',
    chord: 'Chords', stabs: 'Stabs', synth: 'Synths', keys: 'Keys',
    pads: 'Pads', piano: 'Piano', percussion: 'Percussion'
  };

  function labelContent(raw) {
    return CONTENT_LABEL[raw] || raw.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function bpmLabel(bpms) {
    if (!bpms || !bpms.length) return null;
    var min = Math.min.apply(null, bpms);
    var max = Math.max.apply(null, bpms);
    if (min === max) return min + ' BPM';
    return min + '–' + max + ' BPM';
  }

  function renderChips(el, pk) {
    var chips = [];
    var seen = {};
    (pk.c || []).slice(0, 5).forEach(function (c) {
      var lbl = labelContent(c);
      if (!seen[lbl]) { seen[lbl] = 1; chips.push(lbl); }
    });
    var bpm = bpmLabel(pk.b);
    if (bpm) chips.push(bpm);
    chips.push('WAV');
    if ((pk.c || []).indexOf('midi') !== -1) chips.push('MIDI');

    el.innerHTML = chips.map(function (text) {
      return '<span class="ug-pdp-chip">' + text + '</span>';
    }).join('');
    el.hidden = false;
  }

  function init() {
    var article = document.querySelector('[data-ug-pdp-extras]');
    if (!article) return;
    if (article.dataset.pdpExtrasBound === '1') return;

    var chipsEl = article.querySelector('[data-ug-pdp-chips]');
    if (!chipsEl) return;

    var handle = article.getAttribute('data-product-handle');
    var index = window.UG_PACK_INDEX;
    if (!Array.isArray(index)) {
      return setTimeout(init, 150);
    }

    var cur = null;
    for (var i = 0; i < index.length; i++) {
      if (index[i].h === handle) { cur = index[i]; break; }
    }
    if (!cur) {
      chipsEl.hidden = true;
      article.dataset.pdpExtrasBound = '1';
      return;
    }

    article.dataset.pdpExtrasBound = '1';
    renderChips(chipsEl, cur);
  }

  function boot() {
    init();
    document.addEventListener('ug:page-view', init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
